<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card">
            <div class="card-body p-0">
                <angular-editor id="text" [config]="_utilService.defaultEditorConfig" [(ngModel)]="contract_manager"></angular-editor>
                <div class="card-footer text-right">
                    <button routerLink="/dashboard/manager-contract" type="button" rippleEffect class="btn btn-outline-secondary mr-1">{{'BACK' | translate}}</button>
                    <button type="submit" rippleEffect class="btn btn-primary mr-1" (click)="save()">{{'SAVE' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>